function closeFiswearCollectionFilters() {
  document.body.classList.remove('filters-open');
  document.querySelectorAll('.fis-collection-filter-drawer .cc-filters.is-open').forEach(function (filters) {
    filters.classList.remove('is-open');
  });
  document.querySelectorAll('.fis-collection-filter-drawer .cc-filter.is-open').forEach(function (filter) {
    filter.classList.remove('is-open');
  });
}

function initializeFiswearSmartHeader() {
  var headerGroup = document.querySelector('.header-group');
  var siteHeader = headerGroup && headerGroup.querySelector('.fis-site-header');
  if (!headerGroup || !siteHeader || headerGroup.dataset.fisSmartHeaderInitialized === 'true') return;

  headerGroup.dataset.fisSmartHeaderInitialized = 'true';

  var lastScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
  var ticking = false;
  var scrollDelta = 12;

  function getScrollY() {
    return Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
  }

  function syncTopbarHeight() {
    var topbarHeight = Math.max(0, headerGroup.offsetHeight - siteHeader.offsetHeight);
    headerGroup.style.setProperty('--fis-topbar-height', topbarHeight + 'px');
    return topbarHeight;
  }

  function updateHeaderState() {
    var currentScrollY = getScrollY();
    var topbarHeight = syncTopbarHeight();
    var delta = currentScrollY - lastScrollY;
    var menuOpen = headerGroup.querySelector('.fis-mobile-menu[open], .fis-header-language[open]');

    if (currentScrollY <= topbarHeight + 8 || menuOpen) {
      headerGroup.classList.remove('is-fis-header-hidden');
    } else if (delta > scrollDelta) {
      headerGroup.classList.add('is-fis-header-hidden');
    } else if (delta < -scrollDelta) {
      headerGroup.classList.remove('is-fis-header-hidden');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  function requestHeaderUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateHeaderState);
  }

  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
  window.addEventListener('resize', requestHeaderUpdate);
  headerGroup.addEventListener('toggle', requestHeaderUpdate, true);
  updateHeaderState();
}

document.addEventListener('click', function (event) {
  if (!event.target.closest('[data-fis-collection-filter-close]')) return;
  closeFiswearCollectionFilters();
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape' || !document.body.classList.contains('filters-open')) return;
  closeFiswearCollectionFilters();
  var trigger = document.querySelector('.fis-collection-filter-trigger');
  if (trigger) trigger.focus();
});

document.addEventListener('click', function (event) {
  var sliderButton = event.target.closest('[data-fis-slider-button]');
  if (!sliderButton) return;

  var slider = sliderButton.closest('[data-fis-slider]');
  var track = slider && slider.querySelector('[data-fis-slider-track]');
  if (!track) return;

  var cards = Array.prototype.slice.call(track.querySelectorAll('.fis-case-card'));
  if (!cards.length) return;

  var direction = sliderButton.getAttribute('data-fis-slider-button') === 'next' ? 1 : -1;
  var currentIndex = cards.findIndex(function (card) {
    return card.classList.contains('is-active');
  });
  if (currentIndex < 0) currentIndex = 0;

  var currentCard = cards[currentIndex];
  if (currentCard && currentCard.hasAttribute('data-fis-clone')) {
    var logicalIndex = currentCard.getAttribute('data-fis-logical-index');
    var originalCard = track.querySelector('.fis-case-card:not([data-fis-clone])[data-fis-logical-index="' + logicalIndex + '"]');

    if (originalCard) {
      track.scrollTo({
        left: originalCard.offsetLeft - (track.clientWidth - originalCard.clientWidth) / 2,
        behavior: 'auto'
      });
      cards.forEach(function (card) {
        card.classList.toggle('is-active', card === originalCard);
      });
      currentIndex = cards.indexOf(originalCard);
    }
  }

  var targetIndex = currentIndex + direction;
  if (targetIndex < 0) targetIndex = cards.length - 1;
  if (targetIndex >= cards.length) targetIndex = 0;
  var targetCard = cards[targetIndex];
  var targetLeft = targetCard.offsetLeft - (track.clientWidth - targetCard.clientWidth) / 2;

  track.scrollTo({ left: targetLeft, behavior: 'smooth' });
});

function initializeFiswearCaseSliders(root) {
  var scope = root || document;
  var caseSliders = scope.querySelectorAll('[data-fis-slider]');

  caseSliders.forEach(function (slider) {
    if (slider.hasAttribute('data-fis-slider-initialized')) return;

    var track = slider.querySelector('[data-fis-slider-track]');
    var originalCards = track && Array.prototype.slice.call(track.querySelectorAll('.fis-case-card:not([data-fis-clone])'));
    if (!track || !originalCards.length) return;

    slider.setAttribute('data-fis-slider-initialized', 'true');
    var syncRequested = false;
    var loopTimer;

    originalCards.forEach(function (card, index) {
      card.setAttribute('data-fis-logical-index', index);
    });

    if (originalCards.length > 1) {
      var beforeFragment = document.createDocumentFragment();
      var afterFragment = document.createDocumentFragment();

      function cloneCaseCard(card, position) {
        var clone = card.cloneNode(true);
        clone.setAttribute('data-fis-clone', position);
        clone.setAttribute('aria-hidden', 'true');
        clone.classList.remove('is-active');

        clone.querySelectorAll('[id]').forEach(function (element) {
          element.removeAttribute('id');
        });

        return clone;
      }

      originalCards.forEach(function (card) {
        beforeFragment.appendChild(cloneCaseCard(card, 'before'));
        afterFragment.appendChild(cloneCaseCard(card, 'after'));
      });

      track.insertBefore(beforeFragment, originalCards[0]);
      track.appendChild(afterFragment);
    }

    var cards = Array.prototype.slice.call(track.querySelectorAll('.fis-case-card'));

    function centeredScrollLeft(card) {
      return card.offsetLeft - (track.clientWidth - card.clientWidth) / 2;
    }

    function closestCaseIndex() {
      var trackCenter = track.scrollLeft + track.clientWidth / 2;
      var activeIndex = 0;
      var smallestDistance = Infinity;

      cards.forEach(function (card, index) {
        var cardCenter = card.offsetLeft + card.clientWidth / 2;
        var distance = Math.abs(trackCenter - cardCenter);
        if (distance < smallestDistance) {
          smallestDistance = distance;
          activeIndex = index;
        }
      });

      return activeIndex;
    }

    function syncActiveCase() {
      var activeIndex = closestCaseIndex();

      cards.forEach(function (card, index) {
        card.classList.toggle('is-active', index === activeIndex);
      });

      syncRequested = false;
    }

    function normalizeInfinitePosition() {
      var activeCard = cards[closestCaseIndex()];
      var clonePosition = activeCard && activeCard.getAttribute('data-fis-clone');
      if (!clonePosition) return;

      var logicalIndex = Number(activeCard.getAttribute('data-fis-logical-index'));
      var originalCard = originalCards[logicalIndex];
      if (!originalCard) return;

      track.scrollTo({ left: centeredScrollLeft(originalCard), behavior: 'auto' });
      cards.forEach(function (card) {
        card.classList.toggle('is-active', card === originalCard);
      });
    }

    function requestCaseSync() {
      if (syncRequested) return;
      syncRequested = true;
      window.requestAnimationFrame(syncActiveCase);
    }

    track.addEventListener('scroll', function () {
      requestCaseSync();
      window.clearTimeout(loopTimer);
      loopTimer = window.setTimeout(normalizeInfinitePosition, 110);
    }, { passive: true });

    window.addEventListener('resize', function () {
      requestCaseSync();
      window.clearTimeout(loopTimer);
      loopTimer = window.setTimeout(normalizeInfinitePosition, 140);
    });

    window.requestAnimationFrame(function () {
      var initialIndex = window.innerWidth > 640 && originalCards.length > 2 ? 1 : 0;
      var initialCard = originalCards[initialIndex];
      track.scrollLeft = centeredScrollLeft(initialCard);
      syncActiveCase();
    });
  });
}

function initializeFiswearProcessProgress() {
  var processSections = document.querySelectorAll('.fis-home-process');
  if (!processSections.length) return;

  var updateRequested = false;

  function updateProcessProgress() {
    var focusLine = window.innerHeight * 0.44;
    var useStickyLayout = window.innerWidth >= 940 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    processSections.forEach(function (section) {
      var steps = Array.prototype.slice.call(section.querySelectorAll('.fis-process-step'));
      var activeIndex = -1;

      section.classList.toggle('is-sticky-process', useStickyLayout);

      if (useStickyLayout && steps.length) {
        var sectionRect = section.getBoundingClientRect();
        var scrollDistance = Math.max(1, section.offsetHeight - window.innerHeight);
        var sectionProgress = Math.max(0, Math.min(0.9999, -sectionRect.top / scrollDistance));
        activeIndex = Math.min(steps.length - 1, Math.floor(sectionProgress * steps.length));
      } else {
        steps.forEach(function (step, index) {
          if (step.getBoundingClientRect().top <= focusLine) {
            activeIndex = index;
          }
        });
      }

      steps.forEach(function (step, index) {
        step.classList.toggle('is-reached', index <= activeIndex);
        step.classList.toggle('is-current', index === activeIndex);
        step.classList.toggle('is-before', index < activeIndex);
        step.classList.toggle('is-after', index > activeIndex);
        step.classList.toggle('is-next', index === activeIndex + 1);
      });

      section.classList.add('is-scroll-steps');
    });

    updateRequested = false;
  }

  function requestProcessUpdate() {
    if (updateRequested) return;
    updateRequested = true;
    window.requestAnimationFrame(updateProcessProgress);
  }

  window.addEventListener('scroll', requestProcessUpdate, { passive: true });
  window.addEventListener('resize', requestProcessUpdate);
  updateProcessProgress();
}

function initializeFiswearScrollReveals(root) {
  var scope = root || document;
  var revealElements = [];
  var staticElements = scope.querySelectorAll(
    '.fis-site-header__inner, .fis-home-promise__flower, .fis-home-footer__flower, .fis-home-footer__bottom, .fis-home-footer__group'
  );

  staticElements.forEach(function (element) {
    if (window.fiswearRevealObserver) window.fiswearRevealObserver.unobserve(element);
    element.removeAttribute('data-fis-reveal');
    element.classList.remove('is-fis-visible', 'is-fis-reveal-complete');
    element.style.removeProperty('--fis-reveal-delay');
  });

  function register(selector, type, baseDelay, stagger) {
    var elements = Array.prototype.slice.call(scope.querySelectorAll(selector));

    elements.forEach(function (element, index) {
      if (element.hasAttribute('data-fis-reveal')) return;

      element.setAttribute('data-fis-reveal', type || 'up');
      element.style.setProperty('--fis-reveal-delay', ((baseDelay || 0) + (stagger || 0) * index) + 'ms');
      revealElements.push(element);
    });
  }

  function registerCollectionProducts() {
    var elements = Array.prototype.slice.call(scope.querySelectorAll('.fis-collection-product-grid .product-block'));

    elements.forEach(function (element) {
      if (element.hasAttribute('data-fis-reveal')) return;

      element.setAttribute('data-fis-reveal', 'up');
      element.setAttribute('data-fis-product-reveal', '');
      element.style.setProperty('--fis-reveal-delay', '0ms');
      revealElements.push(element);
    });
  }

  register('.fis-home-hero__title', 'up', 40, 0);
  register('.fis-home-hero__copy', 'up', 145, 0);
  register('.fis-home-hero__buttons', 'up', 235, 0);
  register('.fis-home-hero__media', 'scale', 145, 0);
  register('.fis-home-promise__title', 'up', 90, 0);
  register('.fis-home-products .fis-home-section-title', 'up', 0, 0);
  register('.fis-home-products .fis-product-card', 'up', 70, 85);
  register('.fis-home-cases .fis-home-section-title', 'up', 0, 0);
  register('.fis-home-cases .fis-case-slider', 'scale', 90, 0);
  register('.fis-process-intro', 'left', 0, 0);
  register('.fis-photo-grid__heading', 'up', 0, 0);
  register('.fis-photo-grid__viewport', 'scale', 90, 0);
  register('.fis-contact-shell h2', 'up', 0, 0);
  register('.fis-contact-row', 'up', 70, 85);
  register('.fis-contact-form__submit', 'up', 150, 0);
  register('.fis-home-footer__grid > div', 'up', 40, 75);
  register('.fis-story-hero__title', 'up', 40, 0);
  register('.fis-story-hero__lead', 'up', 145, 0);
  register('.fis-story-hero__media', 'scale', 145, 0);
  register('.fis-story-manifesto h2', 'left', 0, 0);
  register('.fis-story-manifesto__text', 'right', 100, 0);
  register('.fis-story-feature__media', 'scale', 0, 0);
  register('.fis-story-feature__content', 'up', 80, 0);
  register('.fis-story-inline-question', 'up', 0, 0);
  register('.fis-business-hero__title', 'up', 40, 0);
  register('.fis-business-hero__text', 'up', 145, 0);
  register('.fis-business-hero__buttons', 'up', 235, 0);
  register('.fis-business-hero__media', 'scale', 145, 0);
  register('.fis-business-proof__intro', 'left', 0, 0);
  register('.fis-business-facts > div', 'up', 80, 90);
  register('.fis-business-tailor__media', 'scale', 0, 0);
  register('.fis-business-tailor__content', 'up', 90, 0);
  register('.fis-collections-hero__title', 'up', 40, 0);
  register('.fis-collections-hero__text', 'up', 145, 0);
  register('.fis-collection-story', 'up', 0, 90);
  register('.fis-collections-promise__inner', 'up', 0, 0);
  // Animate only the heading. A transform on the complete top row would make
  // the fixed filter drawer relative to that row instead of the viewport.
  register('.fis-collection-catalog__heading', 'up', 0, 0);
  registerCollectionProducts();
  register('.template-product .product-layout-grid__images', 'scale', 40, 0);
  register('.template-product .product-detail__title-area', 'up', 65, 0);
  register('.template-product .product-detail__options', 'up', 120, 0);
  register('.template-product .fis-product-quote', 'up', 90, 0);
  register('.template-product .section-image-with-text .image-with-text', 'scale', 0, 0);
  register('.template-product .section-product-recommendations h2', 'up', 0, 0);
  register('.template-cart .cart > .container > .page-width > h1', 'up', 30, 0);
  register('.template-cart .cart-item-container', 'up', 45, 65);
  register('.template-cart .fis-cart-quote', 'up', 80, 0);
  register('.fis-search-hero h1', 'up', 35, 0);
  register('.fis-search-hero__intro', 'up', 105, 0);
  register('.fis-search-form', 'up', 165, 0);
  register('.fis-search-results-heading', 'up', 0, 0);
  register('.fis-search-card, .fis-search-editorial-card', 'up', 30, 55);
  register('.fis-search-empty, .fis-search-start', 'scale', 35, 0);
  register('.fis-contact-page-hero__copy h1', 'up', 35, 0);
  register('.fis-contact-page-hero__intro', 'up', 110, 0);
  register('.fis-contact-page-hero__links', 'up', 175, 0);
  register('.fis-contact-page-hero__image', 'scale', 95, 0);
  register('.fis-contact-page-hero__address', 'up', 185, 0);
  register('.fis-team-hero h1', 'up', 35, 0);
  register('.fis-team-hero__copy', 'up', 115, 0);
  register('.fis-team-card', 'up', 20, 75);
  register('.fis-team-statement__inner', 'scale', 60, 0);
  register('.fis-blog-hero h1', 'up', 35, 0);
  register('.fis-blog-hero__copy', 'up', 120, 0);
  register('.fis-blog-featured', 'scale', 30, 0);
  register('.fis-blog-card', 'up', 20, 65);
  register('.fis-article-hero h1', 'up', 35, 0);
  register('.fis-article-featured-image', 'scale', 80, 0);
  register('.fis-article-content', 'up', 30, 0);
  register('.fis-article-cta__inner', 'scale', 40, 0);
  register('.fis-workshop-hero h1', 'up', 35, 0);
  register('.fis-workshop-hero__intro', 'up', 110, 0);
  register('.fis-workshop-hero__buttons', 'up', 170, 0);
  register('.fis-workshop-facts', 'up', 210, 0);
  register('.fis-workshop-hero__media', 'scale', 90, 0);
  register('.fis-workshop-process__header', 'up', 20, 0);
  register('.fis-workshop-step', 'up', 25, 70);
  register('.fis-workshop-closing__inner', 'scale', 45, 0);
  register('.fis-404-page__number', 'left', 20, 0);
  register('.fis-404-page__copy', 'up', 80, 0);

  if (!revealElements.length) return;

  document.documentElement.classList.add('fis-reveal-ready');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealElements.forEach(function (element) {
      element.classList.add('is-fis-visible', 'is-fis-reveal-complete');
    });
    return;
  }

  var revealObserverEntries = function (entries, observer) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;

      var element = entry.target;
      var delay = parseInt(element.style.getPropertyValue('--fis-reveal-delay'), 10) || 0;
      element.classList.add('is-fis-visible');
      observer.unobserve(element);

      window.setTimeout(function () {
        element.classList.add('is-fis-reveal-complete');
      }, delay + 1050);
    });
  };

  if (!window.fiswearRevealObserver) {
    window.fiswearRevealObserver = new IntersectionObserver(revealObserverEntries, {
      root: null,
      rootMargin: '0px 0px -9% 0px',
      threshold: 0.12
    });
  }

  if (!window.fiswearProductRevealObserver) {
    window.fiswearProductRevealObserver = new IntersectionObserver(revealObserverEntries, {
      root: null,
      rootMargin: '0px 0px 14% 0px',
      threshold: 0.01
    });
  }

  window.requestAnimationFrame(function () {
    window.requestAnimationFrame(function () {
      revealElements.forEach(function (element) {
        if (element.hasAttribute('data-fis-product-reveal')) {
          window.fiswearProductRevealObserver.observe(element);
        } else {
          window.fiswearRevealObserver.observe(element);
        }
      });
    });
  });
}

function initializeFiswearHeroVideos(root) {
  var scope = root || document;
  var videos = scope.querySelectorAll('[data-fis-hero-video]');

  videos.forEach(function (video) {
    if (video.dataset.fisHeroVideoInitialized === 'true') return;

    video.dataset.fisHeroVideoInitialized = 'true';
    video.defaultMuted = true;
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.removeAttribute('controls');

    var playVideo = function () {
      if (!video.paused) return;

      var playAttempt = video.play();
      if (playAttempt && typeof playAttempt.catch === 'function') {
        playAttempt.catch(function () {
          /* A first user interaction triggers another attempt below. */
        });
      }
    };

    video.addEventListener('canplay', playVideo);
    video.addEventListener('loadeddata', playVideo);
    window.addEventListener('pageshow', playVideo);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) playVideo();
    });

    video.load();
    playVideo();
  });
}

function replayFiswearHeroVideos() {
  document.querySelectorAll('[data-fis-hero-video]').forEach(function (video) {
    video.muted = true;
    var playAttempt = video.play();
    if (playAttempt && typeof playAttempt.catch === 'function') {
      playAttempt.catch(function () {});
    }
  });
}

document.addEventListener('pointerdown', replayFiswearHeroVideos, { once: true, passive: true });
document.addEventListener('touchstart', replayFiswearHeroVideos, { once: true, passive: true });

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initializeFiswearSmartHeader();
    initializeFiswearHeroVideos();
    initializeFiswearCaseSliders();
    initializeFiswearProcessProgress();
    initializeFiswearScrollReveals();
  });
} else {
  initializeFiswearSmartHeader();
  initializeFiswearHeroVideos();
  initializeFiswearCaseSliders();
  initializeFiswearProcessProgress();
  initializeFiswearScrollReveals();
}

document.addEventListener('shopify:section:load', function (event) {
  initializeFiswearHeroVideos(event.target);
  initializeFiswearCaseSliders(event.target);
  initializeFiswearScrollReveals(event.target);
});

document.addEventListener('filters-applied', function () {
  var resultCount = document.querySelector('[data-fis-collection-result-count]');
  var visibleCount = document.querySelector('.fis-collection-controls__count');
  if (resultCount && visibleCount) visibleCount.textContent = resultCount.textContent;
  initializeFiswearScrollReveals();
});
